module.exports = "<span class=\"text-capitalize\" [ngClass]=\"className\">{{name}}</span>"